<template>
  <div class="processInformationBox">
    <el-button size="small" type="primary" @click="addBtn">新增</el-button>
    <div class="content">
      <el-table
      :data="tableData"
      :header-cell-style="{ fontWeight: 500, color: 'rgb(0,0,0,0.85)', background: '#fafafa', textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }"
      style="width: 100%">
        <el-table-column prop="technologyName" label="工艺名称" width="180">
          <template slot-scope="{ row }">
            <el-link :underline="false" type="primary" @click="openDrawer(row)">{{ row.technologyName }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="technologyNum" label="工艺编码" width="180"></el-table-column>
        <el-table-column prop="companyId" label="企业编码"></el-table-column>
        <el-table-column prop="reactionType" label="反应类型"></el-table-column>
        <el-table-column prop="finalProduct" label="最终产品"></el-table-column>
        <el-table-column prop="designOrganization" label="设计单位"></el-table-column>
        <el-table-column prop="sfmzgjgdyq" label="是否满足国家规定的要求">
          <template slot-scope="{ row }">
            {{ row.sfmzgjgdyq === 0 ? '否' : '是' }}
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" width="120px">
          <template slot-scope="{ row }">
            <el-link :underline="false" type="primary" @click="editBtn(row)">编辑</el-link>
            <span style="padding: 0 8px; color: #e8e8e8">|</span>
            <el-link :underline="false" type="danger" @click="deleteBtn(row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 15px; text-align: right">
        <Page :total='total' :page-size='limit' :current='curPage' @on-change='curPageChange' />
      </div>
    </div>
    <!-- 详情抽屉 -->
    <el-drawer :visible.sync="drawer" direction="rtl" :before-close="handleClose" size="60%">
      <span slot="title">
        <div style="margin-left: 1%">
          <span style="font-size: 20px">
            <b>{{drawerDetail.technologyNum}}</b>
          </span>
        </div>
        <div style="margin-top: 1%;margin-left: 1%">
          <el-row :gutter="20">
            <el-col :span="4">
              <div class="grid-content bg-purple">
                <b>工艺名称</b>
              </div>
              <div class="grid-content bg-purple" style="margin-top: 3%">
                <span>{{drawerDetail.technologyName}}</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content bg-purple">
                <b>企业编码</b>
              </div>
              <div class="grid-content bg-purple" style="margin-top: 3%">
                <span>{{drawerDetail.companyId}}</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content bg-purple">
                <b>创建时间</b>
              </div>
              <div class="grid-content bg-purple" style="margin-top: 3%">
                <span>{{drawerDetail.gmtCreate}}</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </span>
      <div class="outBox">
        <el-tabs v-model="activeName" style="margin-left: 2%">
          <!-- 工艺详情 -->
          <el-tab-pane label="工艺详情" name="a">
            <div class="detailContentBox">
              <el-form :model="drawerDetail" size="small" label-width="200px" style="padding-top: 20px">
                <!-- <el-col :span="12">
                  <el-form-item label="企业编码">
                    {{ drawerDetail.companyId }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="工艺编码">
                    {{ drawerDetail. }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="生产工艺名称">
                    {{ drawerDetail. }}
                  </el-form-item>
                </el-col> -->
                <el-col :span="12">
                  <el-form-item label="反应类型">
                    {{ drawerDetail.reactionType }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="最终产品">
                    {{ drawerDetail.finalProduct }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="最终产品物质形态">
                    <span v-if="drawerDetail.finalProductForm">{{ productTypeList[drawerDetail.finalProductForm - 1].name }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="中间产品">
                    {{ drawerDetail.middleProduct }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="中间产品物质形态">
                    <span v-if="drawerDetail.middleProductForm === 1">固体</span>
                    <span v-if="drawerDetail.middleProductForm === 2">液体</span>
                    <span v-if="drawerDetail.middleProductForm === 3">气体</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="重点监控单元">
                    {{ drawerDetail.emphasisSu }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="工艺危险特点">
                    {{ drawerDetail.riskCodes }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="重点监控工艺参数">
                    {{ drawerDetail.technologyParameter }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="控制方式">
                    {{ drawerDetail.controlMode }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="自动控制措施">
                    {{ drawerDetail.controlMeasures }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="是否重点监管化工工艺">
                    {{ drawerDetail.supervise === 0 ? '否' : '是' }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="岗位操作人数">
                    {{ drawerDetail.postEmp }}（人）
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="持证人数">
                    {{ drawerDetail.havaCerEmp }}（人）
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="技术来源">
                    {{ drawerDetail.jsly }}
                    <span v-if="drawerDetail.jsly === 1">自行研发</span>
                    <span v-if="drawerDetail.jsly === 2">技术转让</span>
                    <span v-if="drawerDetail.jsly === 3">其他</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="设计单位">
                    {{ drawerDetail.designOrganization }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="工艺系统简况">
                    {{ drawerDetail.intro }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="设计单位资质等级">
                    {{ drawerDetail.designOrganizationLevel }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="是否满足国家规定的要求">
                    {{ drawerDetail.sfmzgjgdyq === 0 ? '否' : '是' }}
                  </el-form-item>
                </el-col>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { processInfoList, processInfoDelete } from "@/api/processManager"
export default {
  name: 'ProcessInformation',
  data() {
    return {
      tableData: [],
      curPage: 1,
      limit: 10,
      total: 0,
      drawer: false,
      infoForm: {},
      activeName: 'a',
      drawerDetail: {}, // 详情页保存的数据
      productTypeList: [
        { id: 1, name: '固态' },
        { id: 2, name: '液态' },
        { id: 3, name: '气态' },
        { id: 4, name: '等离子态' },
      ]
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      processInfoList({ limit: this.limit, curPage: this.curPage, isPage: 1 }).then(res => {
        this.tableData = res.body.data
        this.total = res.body.cum
      })
    },
    addBtn() {
      this.$router.push('AddProcessInformation')
    },
    curPageChange(val) {
      this.curPage = val
      this.getData()
    },
    // 编辑
    editBtn(row) {
      this.$router.push({
        name: 'AddProcessInformation',
        params: { key: row }
      })
    },
    // 删除
    deleteBtn(row) {
      this.$confirm(`删除该工艺信息  《${row.technologyName}》 , 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        processInfoDelete(row.id).then(res => {
          this.$message.success('删除成功')
          this.getData()
        })
      }).catch(() => {
        return
      });
    },
    // 打开抽屉
    openDrawer(row) {
      this.drawerDetail = { ...row }
      this.drawer = true
    },
    // 关闭抽屉
    handleClose() {
      this.drawer = false
    }
  }
}
</script>

<style scoped>
.head {
  width: calc(100% - 280px)
}
.detailContentBox {
  height: 100%;
  background: white;
  overflow: scroll
}
.processInformationBox /deep/ .el-drawer__body {
  height: calc(100% - 100px);
  overflow-y: hidden;
}
.processInformationBox /deep/ .el-tabs__content {
  /* overflow-y: scroll */
  height: 100%;
  overflow-y: hidden
}
.outBox {
  background-color: #e9eef3;
  height: 100%;
  margin-top: 1%;
  padding: 0 15px;
  overflow: scroll
}
</style>
